import { render, staticRenderFns } from "./ScreenScale.vue?vue&type=template&id=2ffe4050"
import script from "./ScreenScale.vue?vue&type=script&lang=js"
export * from "./ScreenScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports